import { Utils } from "helpers/utils";
import { APIClient } from "./apiCore";
import * as url from "./urls";

const api = new APIClient();

const getProfileDetails = () => {
  return api.get(url.GET_PROFILE_DETAILS);
};

export const ucLoadUserConfig = () => {
  // return api.fnPostForm(url.UC_LOAD_USE_CONFIG);
  return api.fnPostForm(url.UC_LOAD_USE_CONFIG, {});
  
};


